//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data(){
        return{
            // 图片路径
            imgUrl:'https://hfb.oss-cn-hangzhou.aliyuncs.com/',
            // 店铺
            store_list:'',
            store_id:'',
            active_store:'',
            sname_list:[],
            active_storeName:'',
            show1:false,
            // 类型类别
            type_list:[],
            type:'全部项目',
            // 预约项目
            project_list: [],
        }
    },
    mounted(){
      // 获取图片路径
      // this.imgUrl =  sessionStorage.getItem('ossPath')
      // 获取所有店铺
      this.$HTTP.HttpPost("/member/rescue/getStoreList", {})
      .then((res) => {
          this.store_list = res.data.data
          // 店铺名数组
          this.store_list.forEach(item => {
              this.sname_list.push(item.store_name)
          });
          // 是否选择了店铺
          let sid = sessionStorage.getItem('sid') - 0
          if(sid){
            this.store_id = sid
          }
          this.select_store()

          this.getTypeList()
      })
      
    },
    methods:{
      // 店铺选择
      select_store(){
        if(!this.store_id){
          this.active_store = this.store_list[0]
          this.store_id = this.store_list[0].sid
          sessionStorage.setItem("sid",this.store_id);
          // console.log(this.store_id);
        }else{
          this.active_store = this.store_list.find(item => {
            return item.sid == this.store_id
          })
          // console.log(this.store_id);
        }
      },
      // 店铺弹窗
      store_popup(){
        this.show1 = true
      },
      // 确定选择店铺
      enter_popup(){
        if(this.active_storeName){
          let act = this.store_list.find(item => {
            return item.store_name == this.active_storeName
          })
          this.active_store = act
          this.store_id = act.sid
          sessionStorage.setItem("sid",this.store_id);
          this.getTypeList()
        }
        // console.log(this.active_store);
        this.show1 = false
      },

      // 获取类型分类
      getTypeList(){
        let data = {
          sid: this.store_id
        }
        this.$HTTP.HttpPost('/member/appointment/getClassifySelect',data)
        .then((res) => {
          this.type_list = res.data.data
          this.getProjectList(0)
        })
      },
      // 切换类型
      changeTab(i){
          if(i == 0){
            this.getProjectList()
          }else{
            this.getProjectList(i)
          }
      },
      // 获取预约项目列表
      getProjectList(i){
        let classify_id = ''
        if(i){
          classify_id = i.id
        }
        let data = {
          classify_id : classify_id,
          sid: this.store_id
        }
        // console.log(data);
        this.$HTTP.HttpPost('/member/appointment/getItemList',data)
        .then((res) => {
          res.data.data.forEach(item => {
            item.picture = this.imgUrl + item.picture
          })
          console.log(res.data.data);
          this.project_list = res.data.data
        })
      },
      // 项目预约按钮
      yuyue_click(i){
        console.log(i);
        this.$router.push({
          name:'/projectdetails',
          params:{
            info:i
          }
        })
      }
    },
}



// WEBPACK FOOTER //
// ./src/components/home/one.vue